var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button -primary buy-btn",class:{'buy-btn-tag': !_vm.isSticky},on:{"click":_vm.ecommercebtn}},[_vm._v(" "+_vm._s(_vm.buyOnlinebuttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }